export default __webpack_public_path__ + "static/media/best.c39ce853.png";